import React from 'react';
import { MultiSelect } from "react-multi-select-component";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { Form, Row, Col } from 'react-bootstrap';

const ServiceMultiSelect = ({
    setSelectedService,

    // Props del MultiSelect
    options = [],
    value = [],
    onChange,
    isLoading = false,
    
    // Props de configuración
    placeholder = "Seleccionar una o más opciones...",
    showValidationError = false,
    validationErrorMessage = "Debe seleccionar al menos un ítem.",
    
    // Props del MultiSelect específicas
    hasSelectAll = true,
    clearSelectedIcon = "🧹Limpiar",
    className = "text-black-color",
    
    // Strings personalizadas
    overrideStrings = {
        selectSomeItems: "Seleccionar una o más opciones...",
        allItemsAreSelected: "Todos los elementos están seleccionados.",
        selectAll: "Seleccionar todo",
        search: "Buscar",
        clearSearch: "Limpiar búsqueda."
    },
    
    // Custom renderer
    valueRenderer,
    
    ...restProps
}) => {

    const handleServiceChange = (newSelection) => {
        if (setSelectedService) {
            setSelectedService(newSelection);
        }
    };

    const defaultValueRenderer = (selected, _options) => {
        return selected.length
            ? selected.map(({ label }) => ` ✔️${label}`)
            : "No hay ítems seleccionados...";
    };

    const multiSelectProps = {
        className,
        options,
        value,
        onChange: handleServiceChange,
        labelledBy: "Select",
        overrideStrings,
        valueRenderer: valueRenderer || defaultValueRenderer,
        hasSelectAll,
        isLoading,
        ClearSelectedIcon: clearSelectedIcon,
        ...restProps
    };

    return (
        <Form.Group as={Row} controlId='service'>
            <Form.Label 
                className='text-right text-black-color pr-0 pl-0 d-flex mandatory-label' 
                column 
                sm='4'
            >
                <FontAwesomeIcon 
                    icon={faAsterisk} 
                    className='mb-2 mr-1 text-danger mandatory-asterisk' 
                />
                Servicio:
            </Form.Label>
            <Col sm='4'>
                <MultiSelect {...multiSelectProps} />
                {showValidationError && (
                    <div className="alert alert-danger form-field-error mb-0 py-1 mt-1" role="alert">
                        {validationErrorMessage}
                    </div>
                )}
            </Col>
        </Form.Group>
    );
};

export default ServiceMultiSelect;